// TestimonialPage.js

import React, { useState } from "react";
import "./Testimonial.css";
import { arrow } from "../../assets/icons";

const testimonialsData = [
  {
    id: 1,
    author: "Stella P.M. Vaz",
    position: "CEO, ALLETS Network",
    content:
      "Zivotix exceeded our expectations. Highly recommended!",
    country: 'Netherlands'
  },
  {
    id: 2,
    author: "Ravish Kumar",
    position: "Founder, Amologic Private Limited",
    content:
      "I'm thoroughly impressed with the professionalism and expertise of the Zivotix team. They not only met but exceeded our expectations. A pleasure to work with",
      country: 'India'
  },
  {
    id: 3,
    author: "Moin Akhtar",
    position: "Founder, Moin Digital Services",
    content:
      "Zivotix created my website flawlessly, demonstrating professionalism, expertise, and exceptional communication throughout the process. Highly recommend",
      country: 'India'
  },
];

const TestimonialPage = () => {
  const [currentTestimonialIndex, setCurrentTestimonialIndex] = useState(0);

  const handlePrevTestimonial = () => {
    setCurrentTestimonialIndex((prevIndex) =>
      prevIndex === 0 ? testimonialsData.length - 1 : prevIndex - 1
    );
  };

  const handleNextTestimonial = () => {
    setCurrentTestimonialIndex((prevIndex) =>
      prevIndex === testimonialsData.length - 1 ? 0 : prevIndex + 1
    );
  };

  const currentTestimonial = testimonialsData[currentTestimonialIndex];

  return (
    <div className="testimonial-box">
      <img
        src={arrow}
        alt="arrow"
        className="arrow-left"
        onClick={handlePrevTestimonial}
      />
      <div className="testimonial-page">
        <div className="testimonial">
          <p>{currentTestimonial.content}</p>
          <p className="author">{currentTestimonial.author}</p>
          <p className="position">{currentTestimonial.position}</p>
          <p className="position">{currentTestimonial.country}</p>
        </div>
      </div>
      <img
        src={arrow}
        alt="arrow"
        className="arrow-right"
        onClick={handleNextTestimonial}
      />
    </div>
  );
};

export default TestimonialPage;
